<template>
  <div class="expire-message-cover">
    <div class="expire-message" id="expire-message">
      <span class="message">{{ strings.first }}</span>
      <img src="@/assets/icons/no_result.svg" alt="Expired">
      <button class="expire-btn">{{ strings.second }}</button>
    </div>
  </div>
</template>

<script>
  import langUtil, { StringKey } from '@/utils/lang.util';

  export default {
    data() {
      return {
        strings: {
          first: langUtil.getLang().t(StringKey.SessionExpiredNew),
          second: langUtil.getLang().t(StringKey.SessionTouchScreenNew),
        },
      };
    },
    mounted() {
      const device = navigator.maxTouchPoints ? 'mobile' : 'computer';

      if (device === 'mobile') {
        document.getElementById('expire-message').classList.add('mobile');
      }
    },
  };
</script>

<style lang="scss">
  .expire-message-cover {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    z-index: 1009;
  }

  .expire-message {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    z-index: 1001;
    text-align: center;

    @media (max-width: 600px) {
      width: 200px;
      padding: 50px 20px;
    }

    img {
      width: 80%;
      min-width: 200px;
      max-width: 250px;
    }

    .message {
      color: #ffffff;
      font-family: 'Nunito-ExtraBold';
      font-size: 25px;
      text-align: center;
      display: block;
      margin-bottom: 20px;

      @media (max-width: 768px) {
        font-size: 22px;
      }

      @media (max-width: 425px) {
        font-size: 16px;
      }
    }

    .expire-btn {
      color: #ffffff;
      font-family: 'Nunito-ExtraBold';
      font-size: 25px;
      display: block;
      margin-top: 25px;
      padding: 10px 20px;
      background: transparent;
      outline: none;
      border: 2px solid #ffffff;
      border-radius: 20px;
      cursor: pointer;
      margin-left: auto;
      margin-right: auto;

      @media (max-width: 768px) {
        font-size: 22px;
      }

      @media (max-width: 425px) {
        font-size: 16px;
      }

      &:hover {
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
        transform: scale(1);
        animation: pulse_button 2s infinite;

        @keyframes pulse_button {
          0% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
          }
          70% {
            transform: scale(1);
            box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
          }
          100% {
            transform: scale(0.95);
            box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
          }
        }
      }
    }

    &.mobile {
      img {
        @media screen and (orientation: landscape) and (min-height: 270px) and (max-height: 768px) {
          width: 50%;
          min-width: unset;
        }
      }
      .message {
        @media screen and (orientation: landscape) and (min-height: 270px) and (max-height: 768px) {
          font-size: 16px;
        }
      }
      .expire-btn {
        @media screen and (orientation: landscape) and (min-height: 270px) and (max-height: 768px) {
          font-size: 14px;
        }
      }
    }
  }
</style>